import { trpc } from "@/Utils/trpc";

import { orderBy } from "lodash";

export const useCustomerParents = () => {
  const {
    data: customerParents,
    isFetching: isLoadingCustomerParents,
    refetch: refetchParents,
    isError,
  } = trpc.customers.getRealEstateBusinessChains.useQuery();

  const isLoading = isLoadingCustomerParents;

  const sortedCustomerParents = orderBy(customerParents, "name");

  return {
    data: sortedCustomerParents || [],
    isLoading,
    isError,
    refetchParents,
  };
};
